<template lang='pug'>
  div
    app-header(:white='true' class='u-absolute')

    section(class='u-flex u-min-height-100vh')
      figure(class='u-m0 u-bg-tertiary u-4/12@tablet u-bg-opacity u-relative' style='z-index:-1;background-image: url(/images/tacna.jpg);background-size: cover;background-position: 50% 50%;')
      div(class='u-py4 u-8/12@tablet u-flex u-items-center u-bg-primary')
        div(class='u-7/12@tablet u-12/12 o-container u-mx-auto')
          h3(class='u-fz-h1 u-white u-line-1 u-mt0 u-mb4' data-aos='fade-right')
            span(class='u-block') Pide un {{company.name}}
            span(class='u-fw-light u-block') desde tu celular

          p(class='u-white u-line-1 u-fz-h4 u-mt0 u-mb4' style='line-height:1.5rem' data-aos='fade-right')
            span(class='u-fw-s-bold') Descarga la aplicación {{company.name}}&nbsp;
            span(class='u-fw-light') en tu móvil con Android y vive tu experiencia en Tacna con {{company.name}}.

          a(:href='company.appLink' v-if='company.appLink' target='_blank' class='u-inline-block' data-aos='fade-right')
            img(src='/images/google_play.png'  class='u-hover-shadow u-block u-inline-block' style='height:50px')

    section(class='u-z2 o-wrapper')
      figure(class='u-ml6 u-mb0 u-mt0 u-show@tablet'  style='margin-top: -80vh; height:110vh;pointer-events: none;' data-aos='fade-up')
        img(src='/images/app.png' style='height:100%;')

      div(class='u-flex u-flex-wrap u-justify-between o-container')
        div(class='u-6/12@laptop u-6/12@tablet u-12/12 u-mb5')
          div(class='u-pt6 u-show@laptop')
          h3(class='u-color-primary u-fz-h2 u-mb3' data-aos='fade-right')
            span Acerca&nbsp;
            span(class='u-fw-light') de la APP

          p(class='u-mb4' data-aos='fade-right')  Haz uso de nuestro nuevo servicio de operador online y haz tus pedidos de taxi más rapido desde tu celular.  Búscanos en la Tienda Play Store en tu dispositivo Android.

          button(v-if='company.appVideo' class='c-btn--primary u-fw-s-bold u-uppercase' @click='isShowModalVideo = true' data-aos='fade-right') Ver Video
        figure(class='u-3/12@laptop u-4/12@tablet u-12/12 u-mb5 u-mt0 u-ml0 u-mr0' data-aos='fade-left')
          img(src='/images/app.png')

    section(class='o-wrapper')
      h3(class='u-color-primary u-fz-h2 u-mt4 u-center' data-aos='fade-up')
        span Características&nbsp;
        span(class='u-fw-light') de la APP

      section(class='u-flex u-flex-wrap u-pb5')
        article(class='u-4/12@laptop u-6/12@tablet u-12/12 u-center u-px4 u-mb4' v-for='feature in features' data-aos='fade-up')
          figure(class='u-mt0 u-mb0 u-mx-auto' style='height:80px')
            img(:src='feature.imageUrl' style='max-height:100%')

          p(class='u-fw-bold u-color-primary u-fz-h4') {{feature.title}}
          p(class='u-mb0') {{feature.description}}

    section(class='u-py5 u-relative')
      figure(class='u-bg-opacity u-absolute u-left-0 u-right-0 u-top-0 u-bottom-0 u-m0' style='z-index:-1;background-image: url(/images/construction.jpg);background-size: cover;background-position: 50% 50%;')
      div(class='o-wrapper o-container')
        h3(class='u-white u-fz-h1 u-mt0 u-mb2' data-aos='zoom-in') Descarga Gratis!
        p(class='u-white' data-aos='zoom-in') Vive tu experiencia en Tacna con {{company.name}}.
        a(class='u-inline-block', :href='company.appLink' target='_blank' data-aos='zoom-in' v-if='company.appLink' )
          img(src='/images/google_play.png' style='height:50px')

    section(class='o-wrapper')
      h3(class='u-color-primary u-fz-h2 u-mb3 u-mt5 u-center' data-aos='fade-up')
        span Interfaces&nbsp;
        span(class='u-fw-light') de la APP

      p(class='u-center u-mb4' data-aos='fade-up') Listado de las pantallas de nuestra aplicación móvil.

      div(class=' u-relative u-mb5 u-12/12')
        button(@click='prev' class='c-btn-nav--prev c-btn-nav--page c-btn-nav c-btn-nav--white' data-aos='fade-up')
          i(class='u-icon') arrow_left
        button(@click='next' class='c-btn-nav--next c-btn-nav--page c-btn-nav c-btn-nav--white' data-aos='fade-up')
          i(class='u-icon') arrow_right

        slick(:options='slickOptions' class='o-wrapper' ref='slick')
          article(v-for='app in apps' data-aos='zoom-in' data-aos-duration="1000")
            figure(class='u-m0')
              img(:src='app.imageUrl')

    section(class='o-wrapper' style='background-position: 0% 100%;background-image: url(/images/footer.png)')
      h3(class='u-color-primary u-fz-h2 u-center u-mt5' data-aos='fade-up')
        span ¿Cómo&nbsp;
        span(class='u-fw-light') usar la APP?

      div(class='u-flex u-justify-between')
        figure(class='u-3/12@laptop u-4/12 u-mb5 u-mt0 u-ml0 u-mr0 u-show@tablet' data-aos='fade-right')
          img(src='/images/app.png')

        aside(class='u-8/12@laptop u-12/12')
          ul(class='u-list-none u-pl0 u-my4 u-flex u-overflow-auto' data-aos='fade-up')
            li(class='u-mr4' v-for='(step, index) in steps' )
              button(class='u-pl0 u-pr0 u-border-bottom u-pb3 u-border-4' @click='selectStep = index'
                :class="selectStep === index ? 'u-border-primary' : 'u-border-white '")
                span(
                  :class="selectStep === index ? 'u-bg-secondary' : 'u-bg-text '"
                  class='u-fz-h5 u-flex u-items-center u-justify-center u-fw-bold c-btn-nav--white u-mx-auto u-mb2') {{index + 1}}
                span(class='u-block u-uppercase u-fw-s-bold', :class="{'u-color-dark' : selectStep === index}") {{step.label}}

            //- li(class='u-mr3')
            //-   button(class='u-pl0 u-pr0 u-border-bottom u-pb3 u-border-4' @click='selectStep'
            //-     :class="selectStep === 1 ? 'u-border-primary' : 'u-border-white '")
            //-     span(
            //-       :class="selectStep === 1 ? 'u-bg-secondary' : 'u-bg-text '"
            //-       class='u-fz-h5 u-flex u-items-center u-justify-center u-fw-bold c-btn-nav--white u-mx-auto u-mb2') 1
            //-     span(class='u-block u-uppercase u-fw-s-bold', :class="{'u-color-dark' : selectStep === 1}") Regístrate
            //-
            //- li(class='u-mx3')
            //-   button(class='u-pl0 u-pr0')
            //-     span(
            //-       :class="selectStep === 2 ? 'u-bg-secondary' : 'u-bg-text '"
            //-       class='u-fz-h5 u-flex u-items-center u-justify-center u-fw-bold c-btn-nav--white u-mx-auto u-mb2') 2
            //-     span(class='u-block u-uppercase u-fw-s-bold') Ubicación

          div(class='u-mb4')
            p(class='u-color-dark u-fz-h4 u-fw-s-bold' data-aos='fade-up') {{steps[selectStep].title}}
            p(data-aos='fade-up') {{steps[selectStep].description}}

    app-footer()
    modal-video(:url='company.appVideo' v-if='isShowModalVideo' @hide='isShowModalVideo = false')
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'AppScreen',
    data () {
      return {
        selectStep: 0,
        isShowModalVideo: false,
        slickOptions: {
          arrows: false,
          centerPadding: '0',
          centerMode: true,
          slidesToScroll: 1,
          slidesToShow: 5,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 320,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
        },
        apps: [
          {
            imageUrl: 'https://lh3.googleusercontent.com/lrhMZZm0BcZEfho7nvUs4SuNl-CJ416jg8O5Q7sBnTkXhm44dL2zuXjKMLRYNlu_SCY=h900-rw'
          },
          {
            imageUrl: 'https://lh3.googleusercontent.com/NHeE4QWA4n9dNmGZ6dwkeCQkE6e4DnbZapLUJGWCq8_ZKDFlSgsO0glNgYvQcB34FF4=h900-rw'
          },
          {
            imageUrl: 'https://lh3.googleusercontent.com/izKVM3z1RZYPcL6dyCdY_Rh2e3rVQkx5yPEwFmbEDFqetFfaqo1_mY495Ayzn-qLkLo=h900-rw'
          }
        ],
        steps: [
          {
            label: 'Registrarte',
            title: 'CREAR CUENTA',
            description: 'Registrate por única vez desde el menú "Crear Cuenta".'
          },
          {
            label: 'Ubicación',
            title: 'CONOCE TU UBICACIÓN',
            description: 'En la pantalla inicial se te ubicará dentro de un mapa.'
          },
          {
            label: 'Reservar',
            title: 'ESCOGE TU PAVILL',
            description: 'Cuando requieras un taxi, presiona el auto de color rojo ubicado en la parte inferior derecha y llena los campos de acuerdo a tu información.'
          },
          {
            label: 'El conductor',
            title: 'SOBRE EL VEHÍCULO Y EL CONDUCTOR',
            description: 'Presiona continuar y espera la confirmación en pantalla, con toda la información del vehículo y conductor.'
          },
          {
            label: 'Estado',
            title: 'CONOCE EL ESTADO DE TU PEDIDO',
            description: 'Realiza un seguimiento en tiempo real, a través del mapa.'
          }
        ],
        features: [
          {
            title: 'Ubicación GPS',
            description: 'Automáticamente la aplicación ubicará tu posición exacta dentro del mapa',
            imageUrl: '/images/feature_1.png'
          },
          {
            title: 'Tu propia cuenta',
            description: 'Puedes registrarte gratuitamente para llevar el historial de tus pedidos',
            imageUrl: '/images/feature_2.png'
          },
          {
            title: 'Sistema de mapas',
            description: 'Se muestra el mapa con las calles de la ciudad, este mapa está bajo el soporte de Google',
            imageUrl: '/images/feature_3.png'
          },
          {
            title: 'Atención las 24hrs.',
            description: 'Nuestra moderna central teléfonica computarizada, te atenderá a cualquier hora del día',
            imageUrl: '/images/feature_4.png'
          },
          {
            title: 'Rápido y fácil de usar',
            description: 'Descarga nuestra aplicación y empieza a realizar tus pedidos fácilmente',
            imageUrl: '/images/feature_5.png'
          },
          {
            title: 'Consulta estado del pedido',
            description: 'Puedes consultar el nro de placa y conductor asignado a tu pedido de taxi',
            imageUrl: '/images/feature_6.png'
          }
        ]
      }
    },

    computed: {
      ...mapGetters({
        company: 'company'
      })
    },

    methods: {
      next () {
        this.$refs.slick.next()
      },

      prev () {
        this.$refs.slick.prev()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/app/screens/App/components/AppScreen.vue